import { createUnleash } from 'shared/unleash/hook';
import type { UnleashToggles } from '@/interfaces';

export const defaultUnleashToggles: UnleashToggles = {
    hotjar: false,
    visbookDirectBooking: false,
    thonDirectBooking: false,
    newAutocomplete: false,
};

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>(defaultUnleashToggles);

export { UnleashProvider, useUnleash };
